module.exports = __webpack_public_path__ + "img/beer_id-118.15b6346a.png";